import PracticesUploadItem from './PracticesUploadItem'

import classes from './GlobalPracticesUpload.module.css'

export default function GlobalPracticesUpload({caseAttorneyId, activeCase, uploadPermission, updatePermission}) {
    return <div className={classes.container}>
        <div className={classes.item}>
            <div className={classes.label}>General HIPAA</div>
            <PracticesUploadItem practiceId={'all'} usedFor={'HIPAA'} caseAttorneyId={caseAttorneyId} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission}/>
        </div>
        <div className={classes.item}>
            <div className={classes.label}>LOR</div>
            <PracticesUploadItem practiceId={'all'} usedFor={'LOR'} caseAttorneyId={caseAttorneyId} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission}/>
        </div>
    </div>
}